import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  // return (
  //   <DefaultFooter
  //     style={{
  //       background: 'none',
  //     }}
  //     copyright="Powered by Ant Desgin"
  //     links={[
  //       {
  //         key: 'Ant Design Pro',
  //         title: 'Ant Design Pro',
  //         href: 'https://pro.ant.design',
  //         blankTarget: true,
  //       },
  //       {
  //         key: 'github',
  //         title: <GithubOutlined />,
  //         href: 'https://github.com/ant-design/ant-design-pro',
  //         blankTarget: true,
  //       },
  //       {
  //         key: 'Ant Design',
  //         title: 'Ant Design',
  //         href: 'https://ant.design',
  //         blankTarget: true,
  //       },
  //     ]}
  //   />
  // );
  

    return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="猋行"
      links={[
        {
          key: '猋行航空箱管理系统',
          title: '猋行航空箱管理系统',
          href: 'https://www.biaohang.net/hi.html',
          blankTarget: true,
        },       
      ]}
    />
  );
};

export default Footer;
